export default __webpack_public_path__ + "media/brands/gstar-8211ea59.png";